export default __webpack_public_path__ + "images/c6aa5795f3a2651ee962ed4c9fed2209-adoption-cat-669.gif";